import store from "@/store";

export function isLoggedIn() {
    return !!store.state.user;
}

export function isAdmin() {
    const user = store.state.user;

    if(user) {
        return user.Partition_Key === "AdminUser";
    }

    return false
}